import EditableCardEntryUserBase from "./EditableCardEntryUserBase";

const EditableCardEntryUserMultiselect = ({fancy = false, isEditing, onEdit, baseValue, displayLabel = "Users", showPCID = false}) => {
    return (
        <EditableCardEntryUserBase
            isEditing={isEditing}
            onEdit={onEdit}
            baseValue={baseValue}
            displayLabel={displayLabel}
            isMultiSelect={true}
            showPCID={showPCID}
            fancy={fancy}
        />
    );
}

export default EditableCardEntryUserMultiselect;